<template>
<v-card flat>
  <v-toolbar dense flat >
    <v-btn
      :loading='statementRequest.loading'
      @click='get' small icon><v-icon small >replay</v-icon></v-btn>
    <v-toolbar-title class='subheading hidden-xs-only' >
      {{ $t('title') }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-divider></v-divider>
  <v-progress-linear
    v-if='statementRequest.loading'
    indeterminate class='ma-0 pa-0' :height='2' >
  </v-progress-linear>
  <v-list class='pb-0' >
    <template v-for='statement in statements' >
      <statement-list-item
        @send='initSend'
        @deleted='get'
        :key='statement.id'
        :value='statement' >
      </statement-list-item>
      <v-divider :key='`div-stat-${statement.id}`' ></v-divider>
    </template>

    <v-card v-if='!statementRequest.loading && statements.length === 0' flat>
      <v-card-title class='subtitle-1 overline' >
        {{ $t('nostatements.title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('nostatements.content') }}
      </v-card-text>
    </v-card>


    <v-dialog v-model='showSendDialog' >
      <v-card flat >
        <v-toolbar dense flat dark :color='themeColor' >
          <v-toolbar-title >
            {{ $t('dialogs.titles.send') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click='showSendDialog = false' ><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <send-statement
          v-if='selectedStatement'
          v-model='selectedStatement'
          :touch='sendTouch'
          @close='showSendDialog = false' >
        </send-statement>
      </v-card>
    </v-dialog>

  </v-list>
</v-card>
</template>
<script>
import SendStatement from '@/components/forms/Statement/SendStatement'
import BatchIdList from '@/components/communications/BatchIdList'
import StatementListItem from '@/components/listitems/StatementListItem'

export default {
  name: 'StatementList',
  props: {
    relationshipId: { required: false },
    touch: { type: Number, default: 0 }
  },
  components: {SendStatement, StatementListItem, BatchIdList},
  data () {
    return {
      reqId: 'get-statement-request',
      showSendDialog: false,
      showDeleteConfirmation: false,
      selectedStatement: null,
      sendTouch: 1
    }
  },
  computed: {
    me () {
      return this.$store.getters.me
    },
    statementRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    statements () {
      return this.getObjectPath(this.statementRequest, 'result.data.results', [])
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    touch () {
      this.get()
    },
    showSendDialog () {
      if (this.showSendDialog === true) {
        this.sendTouch++
      }
    },
    deleteStatementRequestStatus () {
      if (this.deleteStatementRequestStatus === 204) {
        this.get()
      }
    }
  },
  methods: {
    get () {
      let params = {}
      if (this.relationshipId) {
        params.relationship_id = this.relationshipId
      }
      return this.$invoiceguru
        .resource('statements')
        .id(this.reqId)
        .list(params)
    },
    initSend (statement) {
      this.selectedStatement = statement
      this.showSendDialog = true
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Statements',
        dialogs: {
          titles: {
            send: 'Send'
          }
        },
        nostatements: {
          title: 'No statements found for this client',
          content: 'To create a statement, click on the invoices tab, click on the invoices you\'d like to add to the statement and then click on "+ STATEMENT"'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// StatementList.vue?40de606e